import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../api/api.service';
import { IRevenueOverview, ITransactionsRequest, ITransactionsResponse, ITransactionStats } from '../../../_models/payment-transactions.model';


@Injectable({ providedIn: 'root' })
export class PaymentTransactionsService {

  public endpoint: string = "admin";
  constructor(private apiService: ApiService) {}

  // ── Stats ─────────────────────────────────────────
  getStats(): Observable<ITransactionStats> {
    return this.apiService
      .get<any>({ Url: `${this.endpoint}/payments/stats` })
      .pipe(
        map(res => {
          if (!res.auth?.success) {
            throw { msg: res.msg, statusCode: res.auth?.statusCode, success: false };
          }
          return res.data as ITransactionStats;
        })
      );
  }

  // ── Revenue Overview ──────────────────────────────
  getRevenueOverview(period: '7d' | '30d' | '90d' | '1y' = '30d'): Observable<IRevenueOverview> {
    const params = new HttpParams().set('period', period);
    return this.apiService
      .get<any>({ Url: `${this.endpoint}/payments/revenue`, Params: params })
      .pipe(
        map(res => {
          if (!res.auth?.success) {
            throw { msg: res.msg, statusCode: res.auth?.statusCode, success: false };
          }
          return res.data as IRevenueOverview;
        })
      );
  }

  // ── Transactions List ─────────────────────────────
  getTransactions(req: ITransactionsRequest): Observable<ITransactionsResponse> {
    return this.apiService
      .get<any>({ Url: `${this.endpoint}/payments/transactions`, Params: this.buildParams(req) })
      .pipe(
        map(res => {
          if (!res.auth?.success) {
            throw { msg: res.msg, statusCode: res.auth?.statusCode, success: false };
          }
          return res.data as ITransactionsResponse;
        })
      );
  }

  // ── Helpers ───────────────────────────────────────
  private buildParams(req: ITransactionsRequest): HttpParams {
    let p = new HttpParams()
      .set('page',  req.page)
      .set('limit', req.limit);

    if (req.sortBy)    p = p.set('sortBy',    req.sortBy);
    if (req.sortOrder) p = p.set('sortOrder', req.sortOrder);
    if (req.search)    p = p.set('search',    req.search);
    if (req.type)      p = p.set('type',      req.type);
    if (req.status)    p = p.set('status',    req.status);
    if (req.startDate) p = p.set('startDate', req.startDate);
    if (req.endDate)   p = p.set('endDate',   req.endDate);

    return p;
  }

  getPeriods(): { label: string; value: '7d' | '30d' | '90d' | '1y' }[] {
    return [
      { label: '7 Days',  value: '7d'  },
      { label: '30 Days', value: '30d' },
      { label: '90 Days', value: '90d' },
      { label: '1 Year',  value: '1y'  },
    ];
  }

    refundTransaction(id: string): Observable<any> {
    return this.apiService
      .post<any, any>({ Url: `${this.endpoint}/payments/transactions/${id}/refund`, Body: {} })
      .pipe(
        map(res => {
          if (!res.auth?.success) {
            throw { msg: res.msg, statusCode: res.auth?.statusCode, success: false };
          }
          return res.data;
        })
      );
  }
    deleteTransactions(transactionIds: string[]): Observable<any> {
    return this.apiService
      .post<any, any>({ Url: `${this.endpoint}/payments/delete-transactions`, Body: { transactionIds } })
      .pipe(
        map(res => {
          if (!res.auth?.success) {
            throw { msg: res.msg, statusCode: res.auth?.statusCode, success: false };
          }
          return res.data;
        })
      );
  }
}